module.exports = __webpack_public_path__ + "fonts/HelveticaNeueLTPro-Lt.ba55352.woff2";